import { render } from "./ElementZone.vue?vue&type=template&id=5425632e"
import script from "./ElementZone.vue?vue&type=script&lang=js"
export * from "./ElementZone.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__